export const SortBy={
    NAME: 'name',
    DISTANCE: 'distance',
    MIN_RATE: 'minRate',
    MIN_TOTAL: "minTotal",
}

export const addressIcons={
    HOME: 'home-outline',
    WORK: 'briefcase-outline',
    OTHER: "domain",
}

export const Severity={
    ERROR: 'error',
    INFO: 'info',
    SUCCESS: "success",
    WARNING : 'warning'
}

export const Variant={
    FILLED: 'filled',
    OUTLINED: 'outlined',
    STANDART: "standart",
}

